import React, { forwardRef } from 'react'
import { Field, Form, Formik, FormikHelpers } from 'formik'
import cn from 'classnames'
import { FieldPropsType } from '@interfaces/commons/FieldPropsType'
import { UserType } from '@models/user/UserType'

import { UserAvatar } from '@components/UserAvatar'
import { AdminBadgeIcon } from '@components/icons/AdminBadgeIcon'
import { TiptapComment } from './TiptapComment'
import { ReplyUser } from './TiptapComment/interface'

interface CommentBoxProps {
  onSubmit: (
    values: {
      content: string
      wordCount: number
    },
    formikHelpers: FormikHelpers<{
      content: string
      wordCount: number
    }>
  ) => void
  user?: UserType
  replyUser?: ReplyUser
  className?: string
  mode: 'create' | 'edit'
  initialContent?: string
  onCancel?: () => void
  isMainComment?: boolean
}

const CommentBox = forwardRef(
  (
    {
      onSubmit,
      user,
      replyUser,
      className,
      mode,
      initialContent = '<p></p>',
      onCancel,
      isMainComment = false,
    }: CommentBoxProps,
    ref: any
  ) => {
    return (
      <div ref={ref} className={className}>
        <Formik
          initialValues={{ content: initialContent, wordCount: 0 }}
          onSubmit={onSubmit}
        >
          <Form>
            <div
              className={cn(
                'flex desktop:justify-between desktop:items-center items-start pt-[20px] space-x-[20px] tablet-mobile:space-x-[10px]',
                { 'pt-0': mode === 'edit' }
              )}
            >
              {user?.avatarImgPath && mode === 'create' && (
                <div className='relative'>
                  <UserAvatar
                    className='min-w-[50px] w-[50px] h-[50px] object-cover rounded-full'
                    slug={user.profilePageSlug}
                    src={user.avatarImgPath}
                  />
                  {(user?.isAdmin || user?.email === 'admin@mareads.com') && (
                    <div className='absolute bottom-0 right-[-5px]'>
                      <AdminBadgeIcon className='w-[21.5px] h-[21px]' />
                    </div>
                  )}
                </div>
              )}
              <Field name='content'>
                {({ field, meta, form }: FieldPropsType<any>) => (
                  <TiptapComment
                    mode={mode}
                    replyUser={replyUser}
                    initialValue={meta.initialValue}
                    value={field.value}
                    onChange={(value: any, count: number) => {
                      form.setFieldValue('content', value)
                      form.setFieldValue('wordCount', count)
                    }}
                    onCancel={onCancel}
                  />
                )}
              </Field>
            </div>
          </Form>
        </Formik>
      </div>
    )
  }
)

export default CommentBox
